import { render, staticRenderFns } from "./AutomaticCancellations.vue?vue&type=template&id=3ebbfefa&lang=pug"
import script from "./AutomaticCancellations.vue?vue&type=script&lang=js"
export * from "./AutomaticCancellations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports